import React, { useEffect, useRef, useState } from 'react'
import '../styles/Search.scss'
import SearchIcon from '@mui/icons-material/Search'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import ServicesModal from './ServicesModal'
import ServiceTypesModal from '../modals/ServiceTypesModal'
import SelectLocationModal from '../modals/SelectLocationModal'
import { getAllData, getDataById } from '../apis/generalApis'
import FeaturedStylistCard from '../Client/Components/Cards/FeaturedStylistCard'
import AddSkillsModal from '../modals/AddSkillsModal'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import StarIconGolden from '../assets/imgs/star-icon.svg'
import ServiceFilterModal from '../modals/ServiceFilterModal'
import SubServiceFilterModal from '../modals/SubServiceFilterModal'
import DistanceFilterDropdownModal from '../modals/DistanceFilterDropdownModal'
import RatingsFilterModal from '../modals/RatingsFilterModal'
import SortByFilterModal from '../modals/SortByFilterModal'
import { Circle, GoogleMap, Marker } from '@react-google-maps/api'
import { ScaleLoader } from 'react-spinners'

const serviceTypes = [
  'Box Braids (15)',
  'Knotless Braids (23)',
  'Lemonade Braids (16)',
  'Individual Braids (12)',
  'Feed-in Braids (11)',
  'Crown Braids (9)',
  'Braided Up-Dp (20)',
  'Cornrows (25)',
]

const Search = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const clientLocation = JSON.parse(localStorage.getItem('client_location'))
  const [serviceModalOpen, setServiceModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectLocationModal, setSelectLocationModal] = useState(false)
  const [serviceTypesModalOpen, setServiceTypesModalOpen] = useState(false)
  const [center, setCenter] = React.useState({
    lat: Number(user.latitude),
    lng: Number(user.longitude),
  })
  const [selectedService, setselectedService] = useState(null)
  const [selectedSubService, setSelectedSubService] = useState(null)
  const [mapCenter, setMapCenter] = React.useState({
    ...center,
  })
  const [services, setServices] = useState([])
  const [clients, setClients] = useState([])
  const [initialClients, setInitialClients] = useState([])
  const [stylists, setStylists] = useState([])
  const [value, setValue] = React.useState(null)
  const [zipCode, setZipCode] = useState('')
  const [distanceDropdownValue, setDistanceDropdownValue] = useState(10)

  useEffect(() => {
    getAllClients({ user_id: user?.id })
  }, [zipCode])

  useEffect(() => {
    getSingleStylistServices()
  }, [])

  const getSingleStylistServices = async () => {
    setIsLoading(true)
    let result = await getDataById('stylist-services', { stylist_id: user?.id })
    setIsLoading(false)
    if (result?.success === true) {
      setServices(result?.data)
    }
  }
  const searchInputRef = useRef()

  const [selectServiceModal, setSelectServiceModal] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [
    selectedSortDropdownOption,
    setSelectedSortDropdownOption,
  ] = React.useState('')
  const [ratingDropdownOptions, setRatingDropdownOptions] = useState(
    new Array(0).fill({}),
  )
  const [subServiceFilterModal, setSubServiceFilterModal] = useState(false)
  const [distanceFilterModal, setDistanceFilterModal] = useState(false)
  const [serviceFilterModal, setServiceFilterModal] = useState(false)
  const [ratingsFilterModal, setRatingsFilterModal] = useState(false)
  const [sortByFilterModal, setSortByFilterModal] = useState(false)
  const [selectedClient, setSelectedClient] = useState(null)

  const handleSelectServiceModal = () => {
    setSelectServiceModal((prev) => !prev)
  }

  const handleSortByFilterModal = () => {
    setSortByFilterModal((prev) => !prev)
  }

  const getAllClients = async (body) => {
    setIsLoading(true)
    let result = await getDataById('show-clients', body)
    setIsLoading(false)
    if (result?.success === true && result?.data) {
      setClients(result?.data)
      setInitialClients(result?.data)
    }
  }

  const handleRatingsFilterModal = () => {
    setRatingsFilterModal((prev) => !prev)
  }

  const handleServiceModalOpen = () => {
    setServiceModalOpen(!serviceModalOpen)
  }
  const handleSelectLocationModal = () => {
    setSelectLocationModal(!selectLocationModal)
  }
  const handleServiceTypesModalOpen = (modalOpen) => {
    setServiceTypesModalOpen(!serviceTypesModalOpen)
  }

  const handleEnterPress = async (e) => {
    if (e.key === 'Enter') {
      if (searchQuery) {
        setIsLoading(true)
        let result = await getDataById('search-clients', { query: searchQuery })
        setIsLoading(false)
        if (result?.success === true && result?.data) {
          setSearchQuery('')
          setClients(result?.data)
        }
      } else {
        setClients(initialClients)
      }
    }
  }

  const handleSearch = async () => {
    if (searchInputRef?.current?.value) {
      setClients((prev) =>
        initialClients?.filter((el) => {
          let name =
            el?.first_name?.toLowerCase() + el?.last_name?.toLowerCase()
          if (
            name?.includes(searchInputRef?.current?.value?.toLowerCase().replace(/ /g, ''))
          ) {
            return el
          }
        }),
      )
    } else {
      setClients(initialClients)
    }
  }

  const handleServiceFilterModal = () => {
    setServiceFilterModal((prev) => !prev)
  }

  const handleDistanceFilterDropdownModal = () => {
    setDistanceFilterModal((prev) => !prev)
  }

  const handleSubServiceModal = () => {
    setSubServiceFilterModal((prev) => !prev)
  }

  return (
    <div className="search-component">
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="row m-0 py-2 border-primary-btn">
        <div className="col-12 col-sm-12 col-md-6 d-flex align-items-center">
          <div className="client-search-input-wrapper w-100 px-0 px-lg-5">
            <div className="h-100 input-locaiton-wrapper py-2 d-flex align-items-center justify-content-between">
              <div className="search-input h-100 d-flex align-items-center">
                <SearchIcon
                  className="search-icon pointer"
                  // onClick={handleSearch}
                />
                <input
                  type="text"
                  className="fs-18"
                  placeholder="Search for Clients"
                  onChange={handleSearch}
                  // onKeyDown={handleEnterPress}
                  ref={searchInputRef}
                />
              </div>
              <div
                className="location-btn px-4 py-1 pointer"
                onClick={handleSelectLocationModal}
              >
                <p className="m-0 text-white">
                  <LocationOnIcon
                    className="location-icon"
                    style={{ width: '1rem' }}
                  />{' '}
                  {value ? value.label : 'Select Location'}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6">
          <div className="row g-0 mt-0 h-100">
            <div className="col-9 row flex-nowrap overflow-auto m-0 gx-3">
              <div className="col-4 d-flex" style={{ width: '11rem' }}>
                <div className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center w-100">
                  <div
                    onClick={handleDistanceFilterDropdownModal}
                    className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center w-100 px-2"
                  >
                    <p className="fs-18 m-0">Distance</p>
                    <p className="m-0 color-primary fw-bold d-flex align-items-center">
                      {distanceDropdownValue} miles
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-4 d-flex" style={{ width: '12rem' }}>
                <div
                  className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center w-100"
                  onClick={handleRatingsFilterModal}
                >
                  <div className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center w-100 px-2">
                    <p className="fs-18 m-0">Ratings</p>
                    <p className="fs-12 m-0 color-primary fw-bold d-flex align-items-center">
                      <div className="d-flex">
                        <p>
                          {ratingDropdownOptions.length === 0 &&
                            'Select Rating'}
                          {ratingDropdownOptions?.length > 0 && (
                            <span className="d-flex align-items-center gap-1 fs-6">
                              {ratingDropdownOptions?.length}
                              <img
                                src={StarIconGolden}
                                alt="Rating Icon"
                                height={20}
                              />
                            </span>
                          )}
                        </p>
                      </div>
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-4 d-flex" style={{ width: '12rem' }}>
                <div
                  className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center w-100"
                  onClick={handleSortByFilterModal}
                >
                  <div className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center w-100 px-2">
                    <p className="fs-18 m-0">Sort By</p>
                    <p className="m-0 color-primary fw-bold d-flex align-items-center">
                      {selectedSortDropdownOption?.label}
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex align-items-center justify-content-between h-100 px-2 gap-4">
                <span
                  className="fs-15 fw-bold color-primary pointer"
                  onClick={() => {
                    getAllClients({
                      user_id: user?.id,
                      subservice: selectedSubService?.title,
                      rating: ratingDropdownOptions?.length,
                      services: selectedService?.name,
                      distance: distanceDropdownValue,
                      sort_value: selectedSortDropdownOption?.value,
                    })
                  }}
                >
                  Apply Filters
                </span>
                <span
                  className="fs-15 fw-bold pointer"
                  onClick={() => {
                    setDistanceDropdownValue(1)
                    setRatingDropdownOptions(new Array(0).fill({}))
                    setSelectedSortDropdownOption('')
                    setZipCode('')
                    setValue(null)
                    getAllClients({ user_id: user?.id })
                  }}
                >
                  Clear Filters
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row bg-white m-0 g-3">
        <div
          className="col-12 col-md-6 g-3 pb-3"
          style={{ height: 'calc(100vh - 172.57px)', overflow: 'auto' }}
        >
          <div>
            <h1 className="fs-36 py-2 text-black fw-bold m-0 text-center">
              Select client for reservation
            </h1>
          </div>
          <div className="col-12 row gx-2 gy-3">
            {clients &&
              clients?.map((client, index) => (
                <div
                  className="col-12 col-sm-6 col-md-12 col-lg-6 pointer"
                  onClick={() => {
                    setSelectedClient(client)
                    handleSelectServiceModal()
                  }}
                  key={client?.id}
                >
                  <FeaturedStylistCard stylist={client} userType="client" />
                </div>
              ))}
          </div>
        </div>
        <div className="col-12 col-md-6 p-0">
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }}
            center={center}
            zoom={10}
            options={{
              fullscreenControl: false,
              streetViewControl: false,
              mapTypeControl: false,
            }}
          >
            <Marker
              position={
                mapCenter
                // {
                //   lat: -3.745,
                //   lng: -38.523,
                // }
              }
              opacity={1}
              visible={true}
              zIndex={99999999}
            ></Marker>
            <Circle
              center={mapCenter}
              radius={30000}
              visible={true}
              options={
                // {
                //   strokeColor: '#FF0000',
                //   strokeOpacity: 0.8,
                //   strokeWeight: 2,
                //   fillColor: '#FF0000',
                //   fillOpacity: 0.35,
                //   clickable: false,
                //   draggable: false,
                //   editable: false,
                //   visible: true,
                //   radius: 30000,
                //   zIndex: 1,
                // }
                {
                  strokeColor: '#14b1e4',
                  fillColor: '#14b1e4',
                  fillOpacity: 0.16,
                  strokeOpacity: 0.16,
                }
              }
            />
          </GoogleMap>
        </div>
      </div>
      <AddSkillsModal
        handleAddSkillsModal={handleSelectServiceModal}
        toggleAddSkillsModal={selectServiceModal}
        stylistSkills={services}
        selectedClient={selectedClient}
      />
      <ServicesModal
        modalOpen={serviceModalOpen}
        handleServicesModal={handleServiceModalOpen}
      />
      <ServiceTypesModal
        handleServiceTypesModal={handleServiceTypesModalOpen}
        modalOpen={serviceTypesModalOpen}
        serviceTypes={serviceTypes}
      />
      <SelectLocationModal
        handleSelectLocationModal={handleSelectLocationModal}
        selectLocationModal={selectLocationModal}
        mapCenter={mapCenter}
        setCenter={setCenter}
        value={value}
        setValue={setValue}
        center={center}
        setZipCode={setZipCode}
      />
      <DistanceFilterDropdownModal
        distanceFilterModal={distanceFilterModal}
        handleDistanceFilterDropdownModal={handleDistanceFilterDropdownModal}
        distanceDropdownValue={distanceDropdownValue}
        setDistanceDropdownValue={setDistanceDropdownValue}
      />
      <RatingsFilterModal
        handleRatingsFilterModal={handleRatingsFilterModal}
        ratingsFilterModal={ratingsFilterModal}
        ratingDropdownOptions={ratingDropdownOptions}
        setRatingDropdownOptions={setRatingDropdownOptions}
      />
      <SortByFilterModal
        handleSortByFilterModal={handleSortByFilterModal}
        sortByFilterModal={sortByFilterModal}
        selectedSortDropdownOption={selectedSortDropdownOption}
        setSelectedSortDropdownOption={setSelectedSortDropdownOption}
      />
    </div>
  )
}

export default Search
